// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio_project_info_header_box__hdkP2 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    margin-bottom: 10px;
    align-items: center;
    justify-content: center;
}

.portfolio_project_info_box__b5cKH {
    z-index: 1;
    width: 100%;
    height: 27px;
    max-width: 250px;
    border-radius: 50px;
    position: relative;
    background-color: #24261F;
}
.portfolio_project_info_box__b5cKH p {
    margin: 0;
    margin-top: 7px;
    font-size: 10px;
    color: #FFFFFF;
    font-family: "Gothic";
}

.portfolio_right_slider_button_box__P\\+boU {
    width: 50px;
    height: 25px;
    display: flex;
    flex-wrap: wrap;
    border-radius: 50px;
    align-items: center;
    justify-content: center;
    border: 2px solid #D6E5B8;
}
.portfolio_right_slider_button_box__P\\+boU div {
    width: 15px;
    height: 15px;
    transform: rotate(90deg);
    background-color: #D6E5B8;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.portfolio_project_info_body_box__1Vqou {
    width: 56.8%;
}

.portfolio_left_slider_button_box__wk3fU {
    width: 50px;
    height: 25px;
    display: flex;
    flex-wrap: wrap;
    border-radius: 50px;
    align-items: center;
    justify-content: center;
    border: 2px solid #D6E5B8;
}
.portfolio_left_slider_button_box__wk3fU div {
    width: 15px;
    height: 15px;
    transform: rotate(-90deg);
    background-color: #D6E5B8;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.portfolio_product_info_header_background__IF6Wv {
    width: 100%;
    height: 55px;
    max-width: 315px;
    margin-top: -14px;
    margin-bottom: 198px;
    border-radius: 50px;
    border: 2px solid #D6E5B8;
}
.portfolio_product_info_header_background__IF6Wv p {
    margin: 0;
    font-size: 10px;
    color: #FFFFFF;
    margin-top: 25px;
    font-family: "Arial";
}

.portfolio_location_box__s9uhK {
    z-index: 2;
    width: 100%;
    display: flex;
    direction: ltr;
    flex-wrap: wrap;
    margin-top: 7px;
    position: relative;
    align-items: center;
    justify-content: center;
}

.portfolio_product_info_header_background__IF6Wv img {
    margin: 0;
    width: 15px;
    height: 15px;
    margin-right: 3px;
}
.portfolio_product_info_header_background__IF6Wv span {
    margin: 0;
    font-size: 10px;
    color: #FFFFFF;
    margin-bottom: -2px;
    font-family: "Arial";
}

.portfolio_product_info_right_body__E2tU8 {
    display: none !important;
}

.portfolio_project_banner_box__TsaD9 {
    width: 100%;
    height: 197px;
    overflow: hidden;
    max-width: 360px;
    overflow: hidden;
    margin-top: -160px;
    position: relative;
    background: #000;
    border-radius: 10px;
    aspect-ratio: 16 / 9;
    border: 1px solid #D6E5B8;
    border-top: none;
}
.portfolio_project_banner_box__TsaD9 img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.portfolio_portfolio_service_box__Rrw9u {
    margin-top: 10px;
    margin-bottom: 67px;
}

.portfolio_project_banner_desktop_box__GlXtK {
    display: none;
}

.portfolio_spinner_bar_box__fiBSk {
    width: 100%;
}

.portfolio_Project_Text_Info_Frame_Desktop__D6QNj {
    display: none;
    margin-top: 110px;
}
.portfolio_Project_Text_Info_Frame_Desktop__D6QNj div {
    text-align: right;
    margin-right: 50px;
    margin-bottom: -30px;
}
.portfolio_Project_Text_Info_Frame_Desktop__D6QNj h3 {
    font-size: 35px;
}
.portfolio_Project_Text_Info_Frame_Desktop__D6QNj span {
    font-size: 16px;
    margin-right: -20px;
}
.portfolio_Project_Text_Info_Frame_Desktop__D6QNj img {
    width: 25px;
    height: 25px;
    margin-bottom: -8px;
}

@media (min-width: 1200px) {
    .portfolio_project_banner_box__TsaD9 {
        height: 300px;
        display: none;
        max-width: 533px;
        margin-top: -160px;
        border-radius: 30px;
        border: 1px solid #D6E5B8;
    }
    .portfolio_project_banner_box__TsaD9::before {
        display: none;
    }

    .portfolio_project_info_box__b5cKH {
        height: 62px;
        max-width: 800px;
        border-radius: 100px;
    }
    .portfolio_project_info_box__b5cKH p {
        font-size: 20px;
        margin-top: 17px;
    }

    .portfolio_right_slider_button_box__P\\+boU {
        width: 100px;
        height: 60px;
        cursor: pointer;
        border-radius: 100px;
    }
    .portfolio_right_slider_button_box__P\\+boU div {
        width: 30px;
        height: 30px;
    }

    .portfolio_left_slider_button_box__wk3fU {
        width: 100px;
        height: 60px;
        cursor: pointer;
        border-radius: 100px;
    }
    .portfolio_left_slider_button_box__wk3fU div {
        width: 30px;
        height: 30px;
    }

    .portfolio_project_info_body_box__1Vqou {
        width: 74%;
    }

    .portfolio_product_info_header_background__IF6Wv div {
        justify-content: flex-start;
    }

    .portfolio_product_info_right_body__E2tU8 {
        width: 50% !important;
        display: block !important;
        margin-top: 96px !important;
    }

    .portfolio_product_info_left_body__9OfaC {
        width: 50% !important;
    }

    .portfolio_product_info_header_background__IF6Wv {
        height: 635px;
        max-width: 1200px;
        margin-top: -30px;
        border-radius: 30px;
        margin-bottom: 64px;
        border: 1px solid #D6E5B8;
    }
    .portfolio_product_info_header_background__IF6Wv p {
        font-size: 35px;
        text-align: left;
        margin-left: 31px;
        margin-top: 115px;
    }
    .portfolio_product_info_header_background__IF6Wv img {
        width: 30px;
        height: 30px;
        margin-top: 11px;
        margin-left: 28px;
        margin-right: 5px;
    }
    .portfolio_product_info_header_background__IF6Wv span {
        font-size: 20px;
        margin-top: 16px;
        margin-bottom: 0px;
    }

    .portfolio_Project_Text_Info_Frame__33zus {
        display: none;
    }

    .portfolio_portfolio_service_box__Rrw9u {
        display: none;
    }

    .portfolio_portfolio_content_box__XdW5W {
        display: flex;
        flex-wrap: wrap;
        margin-top: -276px;
        align-items: center;
        justify-content: flex-start;
    }

    .portfolio_portfolio_content_show__A8KIl {
        width: 50%;
        width: 634px;
        display: flex;
        flex-wrap: wrap;
        margin-top: -150px;
        align-items: center;
        justify-content: flex-start;
    }

    .portfolio_project_banner_desktop_box__GlXtK {
        width: 45%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
    }
    .portfolio_project_banner_desktop_box__GlXtK div {
        width: 100%;
        height: 300px;
        overflow: hidden;
        max-width: 533px;
        margin-top: -160px;
        border-radius: 30px;
        border: 1px solid #D6E5B8;
    }

    .portfolio_spinner_bar_box__fiBSk {
        width: 41.66%;
        margin-top: -200px;
    }

    .portfolio_Project_Text_Info_Frame_Desktop__D6QNj {
        display: inline-block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/portfolio/portfolio.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,2BAA2B;IAC/B;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".project_info_header_box {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 50px;\r\n    margin-bottom: 10px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.project_info_box {\r\n    z-index: 1;\r\n    width: 100%;\r\n    height: 27px;\r\n    max-width: 250px;\r\n    border-radius: 50px;\r\n    position: relative;\r\n    background-color: #24261F;\r\n}\r\n.project_info_box p {\r\n    margin: 0;\r\n    margin-top: 7px;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.right_slider_button_box {\r\n    width: 50px;\r\n    height: 25px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    border-radius: 50px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid #D6E5B8;\r\n}\r\n.right_slider_button_box div {\r\n    width: 15px;\r\n    height: 15px;\r\n    transform: rotate(90deg);\r\n    background-color: #D6E5B8;\r\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n}\r\n\r\n.project_info_body_box {\r\n    width: 56.8%;\r\n}\r\n\r\n.left_slider_button_box {\r\n    width: 50px;\r\n    height: 25px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    border-radius: 50px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid #D6E5B8;\r\n}\r\n.left_slider_button_box div {\r\n    width: 15px;\r\n    height: 15px;\r\n    transform: rotate(-90deg);\r\n    background-color: #D6E5B8;\r\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n}\r\n\r\n.product_info_header_background {\r\n    width: 100%;\r\n    height: 55px;\r\n    max-width: 315px;\r\n    margin-top: -14px;\r\n    margin-bottom: 198px;\r\n    border-radius: 50px;\r\n    border: 2px solid #D6E5B8;\r\n}\r\n.product_info_header_background p {\r\n    margin: 0;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n    margin-top: 25px;\r\n    font-family: \"Arial\";\r\n}\r\n\r\n.location_box {\r\n    z-index: 2;\r\n    width: 100%;\r\n    display: flex;\r\n    direction: ltr;\r\n    flex-wrap: wrap;\r\n    margin-top: 7px;\r\n    position: relative;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.product_info_header_background img {\r\n    margin: 0;\r\n    width: 15px;\r\n    height: 15px;\r\n    margin-right: 3px;\r\n}\r\n.product_info_header_background span {\r\n    margin: 0;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n    margin-bottom: -2px;\r\n    font-family: \"Arial\";\r\n}\r\n\r\n.product_info_right_body {\r\n    display: none !important;\r\n}\r\n\r\n.project_banner_box {\r\n    width: 100%;\r\n    height: 197px;\r\n    overflow: hidden;\r\n    max-width: 360px;\r\n    overflow: hidden;\r\n    margin-top: -160px;\r\n    position: relative;\r\n    background: #000;\r\n    border-radius: 10px;\r\n    aspect-ratio: 16 / 9;\r\n    border: 1px solid #D6E5B8;\r\n    border-top: none;\r\n}\r\n.project_banner_box img {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n}\r\n\r\n.portfolio_service_box {\r\n    margin-top: 10px;\r\n    margin-bottom: 67px;\r\n}\r\n\r\n.project_banner_desktop_box {\r\n    display: none;\r\n}\r\n\r\n.spinner_bar_box {\r\n    width: 100%;\r\n}\r\n\r\n.Project_Text_Info_Frame_Desktop {\r\n    display: none;\r\n    margin-top: 110px;\r\n}\r\n.Project_Text_Info_Frame_Desktop div {\r\n    text-align: right;\r\n    margin-right: 50px;\r\n    margin-bottom: -30px;\r\n}\r\n.Project_Text_Info_Frame_Desktop h3 {\r\n    font-size: 35px;\r\n}\r\n.Project_Text_Info_Frame_Desktop span {\r\n    font-size: 16px;\r\n    margin-right: -20px;\r\n}\r\n.Project_Text_Info_Frame_Desktop img {\r\n    width: 25px;\r\n    height: 25px;\r\n    margin-bottom: -8px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .project_banner_box {\r\n        height: 300px;\r\n        display: none;\r\n        max-width: 533px;\r\n        margin-top: -160px;\r\n        border-radius: 30px;\r\n        border: 1px solid #D6E5B8;\r\n    }\r\n    .project_banner_box::before {\r\n        display: none;\r\n    }\r\n\r\n    .project_info_box {\r\n        height: 62px;\r\n        max-width: 800px;\r\n        border-radius: 100px;\r\n    }\r\n    .project_info_box p {\r\n        font-size: 20px;\r\n        margin-top: 17px;\r\n    }\r\n\r\n    .right_slider_button_box {\r\n        width: 100px;\r\n        height: 60px;\r\n        cursor: pointer;\r\n        border-radius: 100px;\r\n    }\r\n    .right_slider_button_box div {\r\n        width: 30px;\r\n        height: 30px;\r\n    }\r\n\r\n    .left_slider_button_box {\r\n        width: 100px;\r\n        height: 60px;\r\n        cursor: pointer;\r\n        border-radius: 100px;\r\n    }\r\n    .left_slider_button_box div {\r\n        width: 30px;\r\n        height: 30px;\r\n    }\r\n\r\n    .project_info_body_box {\r\n        width: 74%;\r\n    }\r\n\r\n    .product_info_header_background div {\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .product_info_right_body {\r\n        width: 50% !important;\r\n        display: block !important;\r\n        margin-top: 96px !important;\r\n    }\r\n\r\n    .product_info_left_body {\r\n        width: 50% !important;\r\n    }\r\n\r\n    .product_info_header_background {\r\n        height: 635px;\r\n        max-width: 1200px;\r\n        margin-top: -30px;\r\n        border-radius: 30px;\r\n        margin-bottom: 64px;\r\n        border: 1px solid #D6E5B8;\r\n    }\r\n    .product_info_header_background p {\r\n        font-size: 35px;\r\n        text-align: left;\r\n        margin-left: 31px;\r\n        margin-top: 115px;\r\n    }\r\n    .product_info_header_background img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin-top: 11px;\r\n        margin-left: 28px;\r\n        margin-right: 5px;\r\n    }\r\n    .product_info_header_background span {\r\n        font-size: 20px;\r\n        margin-top: 16px;\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .Project_Text_Info_Frame {\r\n        display: none;\r\n    }\r\n\r\n    .portfolio_service_box {\r\n        display: none;\r\n    }\r\n\r\n    .portfolio_content_box {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        margin-top: -276px;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .portfolio_content_show {\r\n        width: 50%;\r\n        width: 634px;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        margin-top: -150px;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .project_banner_desktop_box {\r\n        width: 45%;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n    }\r\n    .project_banner_desktop_box div {\r\n        width: 100%;\r\n        height: 300px;\r\n        overflow: hidden;\r\n        max-width: 533px;\r\n        margin-top: -160px;\r\n        border-radius: 30px;\r\n        border: 1px solid #D6E5B8;\r\n    }\r\n\r\n    .spinner_bar_box {\r\n        width: 41.66%;\r\n        margin-top: -200px;\r\n    }\r\n\r\n    .Project_Text_Info_Frame_Desktop {\r\n        display: inline-block;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"project_info_header_box": `portfolio_project_info_header_box__hdkP2`,
	"project_info_box": `portfolio_project_info_box__b5cKH`,
	"right_slider_button_box": `portfolio_right_slider_button_box__P+boU`,
	"project_info_body_box": `portfolio_project_info_body_box__1Vqou`,
	"left_slider_button_box": `portfolio_left_slider_button_box__wk3fU`,
	"product_info_header_background": `portfolio_product_info_header_background__IF6Wv`,
	"location_box": `portfolio_location_box__s9uhK`,
	"product_info_right_body": `portfolio_product_info_right_body__E2tU8`,
	"project_banner_box": `portfolio_project_banner_box__TsaD9`,
	"portfolio_service_box": `portfolio_portfolio_service_box__Rrw9u`,
	"project_banner_desktop_box": `portfolio_project_banner_desktop_box__GlXtK`,
	"spinner_bar_box": `portfolio_spinner_bar_box__fiBSk`,
	"Project_Text_Info_Frame_Desktop": `portfolio_Project_Text_Info_Frame_Desktop__D6QNj`,
	"product_info_left_body": `portfolio_product_info_left_body__9OfaC`,
	"Project_Text_Info_Frame": `portfolio_Project_Text_Info_Frame__33zus`,
	"portfolio_content_box": `portfolio_portfolio_content_box__XdW5W`,
	"portfolio_content_show": `portfolio_portfolio_content_show__A8KIl`
};
export default ___CSS_LOADER_EXPORT___;
